import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

/**
 * Styles for the modal portal container (rendered by `ModalProvider`). Applied directly to the container
 * element via `className` instead of a global stylesheet so it can be extracted at build time.
 */
export const modalContainer = css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${theme.zIndex.modals};

  :focus {
    outline: none;
  }
`;
